import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/sr';

const Table = ({ clusters, user }) => {
  return (
    <div className="table">
      <table className="table is-bordered is-hoverable">
        <thead>
          <tr>
            <th>Datum</th>
            <th>Pretvaranje</th>
            <th>Standardni</th>
            <th>Oba</th>
          </tr>
        </thead>
        <tbody>
          {user ? (
            <tr>
              <td className="date-stats"><strong className="has-text-info">Ukupno //</strong></td>
              <td><strong className="has-text-info">{user.stats.exp}/{user.stats.all}</strong></td>
              <td><strong className="has-text-info">{user.stats.standard}/{user.stats.all}</strong></td>
              <td><strong className="has-text-info">{user.stats.full}/{user.stats.all}</strong></td>
            </tr>
          ):(
            null
          )}
        {console.log(clusters[0])}
          {clusters.map(cluster => (
            <tr key={cluster.id}>
              <td className="date-stats">{dayjs(cluster.dateCreated).locale('sr').format('D. MMM YYYY. dddd')}<strong>{dayjs(cluster.dateCreated).locale('sr').format(' HH:mm:ss')}</strong></td>
              <td className={cluster.expSolved ? 'not-null' : undefined}>{cluster.expSolved}/{cluster.numOfProblems}</td>
              <td className={cluster.standardSolved ? 'not-null' : undefined}>{cluster.standardSolved}/{cluster.numOfProblems}</td>
              <td className={cluster.solved ? 'not-null' : undefined}>{cluster.solved}/{cluster.numOfProblems}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Table;
